import React, { Component } from 'react'
import AuthenticationService from './AuthenticationService'
import { Config } from '../../Config'
import { BrowserRouter as Router, Route, Link, Redirect } from "react-router-dom";
// import AuthenticationService from '../../components/Common/UserContext'

export default function authenticate (AuthenticationComponent) {
  // Code here now
  // const authenticationService = new AuthenticationService(Config.authUrl)

  return class AuthWrapped extends Component {
    constructor () {
      super()

      this.authService = new AuthenticationService(Config.authBaseUrl)

      this.state = {
        user: null,
        isLoggedIn: false,
        url: null
      }
    }

    componentWillMount () {
      if (!this.authService.isLoggedIn()) {
        this.state.url = window.location.pathname + window.location.search;
        this.setState({ isLoggedIn: false });

      } else {
        if (window.location.pathname.indexOf('/admin') > -1 || window.location.pathname.indexOf('/systems') > -1) {
          let user = this.authService.getProfile()
          if (user.User_EmailAddress) {
            window.location.href = '/welcome'
          }
        }
        if (!this.authService.isMasquerade()) {
          let TOSAgree = this.authService.getProfile().Account_TOS_Agree
          let accountDFAIsDFA = this.authService.getProfile().Account_DFA_IsDFA
          let isDFAVerified = window.localStorage.getItem('isDFAVerified') || 0
          if (!isDFAVerified && accountDFAIsDFA !== null && accountDFAIsDFA === 1) {
            if (window.location.pathname !== '/validateDfaAuth') {
              window.location.href = '/validateDfaAuth'
            }
          } else if (TOSAgree === 0 || TOSAgree === null) {
            if (window.location.pathname !== '/myAccount' && window.location.pathname !== '/logout') {
              window.location.href = '/myAccount'
            }
          } else if (window.location.hostname !== 'localhost') {
            if (window.location.pathname === '/connect' && window.location.protocol === 'https:') {
              window.location.href = window.location.href.replace('https', 'http')
            } else if (window.location.pathname !== '/connect' && window.location.protocol === 'http:') {
              window.location.href = window.location.href.replace('http', 'https')
            }
          }
        }
        this.setState({ isLoggedIn: true })
      }
    }
    render () {
      if (this.state.isLoggedIn) {
        return (
          <AuthenticationComponent history={this.props.history} user={this.state.user}/>
        )
      } else {
        return (<Redirect 
          to={{
          pathname: "/logout",
          state: { referrer: this.state.url  }
        }} />)
        // return null;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Security/Authentication.js